// import React from 'react';
import HomeIcon from './assets/svgs/MenuIcons/HomeIcon.svg';
import PackagesIcon from './assets/svgs/MenuIcons/PackagesIcon.svg';
import SitesIcon from './assets/svgs/MenuIcons/SitesIcon.svg';
import UsersIcon from './assets/svgs/MenuIcons/UsersIcon.svg';
import VoucherIcon from './assets/svgs/MenuIcons/VoucherIcon.svg';
import DevicesIcon from './assets/svgs/MenuIcons/DevicesIcon.svg';

import { getUserType } from './helpers/userDetails';
import BatchesPage from './pages/BatchesPage';
import ChangePasswordPage from './pages/ChangePasswordPage';
import CompanyDetailsPage from './pages/CompanyDetailsPage';
import CompanyLoginAsCEOPage from './pages/CompanyLoginAsCEOPage';
import EditProfilePage from './pages/EditProfilePage';
import HomePage from './pages/HomePage';
import MasterStaffRouterDetailsPage from './pages/MasterStaffRouterDetailsPage';
import MasterStaffSiteDetailsPage from './pages/MasterStaffSiteDetailsPage';
import MasterStaffUpdateProfilePage from './pages/MasterStaffUpdateProfilePage';
import MasterStaffUpdatePasswordPage from './pages/MasterStaffUpdatePasswordPage';
import PackagesPage from './pages/PackagesPage';
import RadBotNodesPage from './pages/RadBotNodesPage';
import RouterDetailsPage from './pages/RouterDetailsPage';
import RouterSearchPage from './pages/RouterSearchPage';
import SingleBatchPage from './pages/SingleBatchPage';
import SinglePackagePage from './pages/SinglePackagePage';
import SingleSitePage from './pages/SingleSitePage';
import SitesPage from './pages/SitesPage';
import StaffPage from './pages/StaffPage';
import VoucherSearchPage from './pages/VoucherSearchPage';

const routesList: Array<Route> = [
  {
    path: '/',
    Component: HomePage,
    roles: ['ADMIN', 'MANAGER', 'SUPPORT', 'MASTER_ADMIN', 'MASTER_NOC'],
    text: 'Home',
    show: true,
    icon: HomeIcon,
  },
  {
    path: '/sites',
    Component: SitesPage,
    roles: ['ADMIN', 'MANAGER', 'SUPPORT'],
    text: 'Sites',
    show: true,
    icon: SitesIcon,
  },
  {
    path: '/site-details/:intPkCompanySiteID',
    Component: SingleSitePage,
    roles: ['ADMIN', 'MANAGER', 'SUPPORT'],
    text: 'Site details',
    show: false,
    icon: '',
  },
  {
    path: '/router-details/:intPkSiteCoreRouterID',
    Component: RouterDetailsPage,
    roles: ['ADMIN', 'MANAGER', 'SUPPORT'],
    text: 'Router Details',
    show: false,
    icon: '',
  },
  {
    path: '/packages',
    Component: PackagesPage,
    roles: ['ADMIN', 'MANAGER', 'SUPPORT'],
    text: 'Packages',
    show: true,
    icon: PackagesIcon,
  },
  {
    path: '/package-details/:intPkPackageID',
    Component: SinglePackagePage,
    roles: ['ADMIN', 'MANAGER', 'SUPPORT'],
    text: 'Package Details',
    show: false,
    icon: '',
  },
  {
    path: '/batches',
    Component: BatchesPage,
    roles: ['ADMIN', 'MANAGER'],
    text: 'Batches',
    show: true,
    icon: VoucherIcon,
  },
  {
    path: '/batch-details/:intPkBatchID',
    Component: SingleBatchPage,
    roles: ['ADMIN', 'MANAGER'],
    text: 'Batch Details',
    show: false,
    icon: '',
  },
  {
    path: '/voucher-search',
    Component: VoucherSearchPage,
    roles: ['ADMIN', 'MANAGER', 'SUPPORT'],
    text: 'Search Voucher',
    show: true,
    icon: VoucherIcon,
  },
  {
    path: '/staff',
    Component: StaffPage,
    roles: ['ADMIN'],
    text: 'Staff',
    show: true,
    icon: UsersIcon,
  },

  {
    path: '/edit-profile',
    Component: EditProfilePage,
    roles: ['ADMIN', 'MANAGER', 'SUPPORT'],
    text: 'Edit Profile',
    show: false,
    icon: '',
  },
  {
    path: '/change-password',
    Component: ChangePasswordPage,
    roles: ['ADMIN', 'MANAGER', 'SUPPORT'],

    text: 'Change Password',
    show: false,
    icon: '',
  },
  {
    path: '/company/:intPkCompanyID',
    Component: CompanyDetailsPage,
    roles: ['MASTER_ADMIN', 'MASTER_NOC'],
    text: 'Company Details',
    show: false,
    icon: '',
  },
  {
    path: '/master-staff-site-details/:intPkCompanySiteID',
    Component: MasterStaffSiteDetailsPage,
    roles: ['MASTER_ADMIN', 'MASTER_NOC'],
    text: 'Site Details',
    show: false,
    icon: '',
  },
  {
    path: '/master-staff-router-details/:intPkSiteCoreRouterID',
    Component: MasterStaffRouterDetailsPage,
    roles: ['MASTER_ADMIN', 'MASTER_NOC'],
    text: 'Router Details',
    show: false,
    icon: '',
  },
  {
    path: '/company-login/:intPkCompanyID',
    Component: CompanyLoginAsCEOPage,
    roles: ['MASTER_ADMIN', 'MASTER_NOC'],
    text: 'Companies',
    show: false,
    icon: '',
  },
  {
    path: '/auth/masterstaff/update-profile',
    Component: MasterStaffUpdateProfilePage,
    roles: ['MASTER_ADMIN', 'MASTER_NOC'],
    text: 'Update Profile',
    show: false,
    icon: '',
  },
  {
    path: '/auth/masterstaff/update-password',
    Component: MasterStaffUpdatePasswordPage,
    roles: ['MASTER_ADMIN', 'MASTER_NOC'],
    text: 'Update Password',
    show: false,
    icon: '',
  },
  {
    path: '/router-search',
    Component: RouterSearchPage,
    roles: ['MASTER_ADMIN', 'MASTER_NOC'],
    text: 'Search Router',
    show: true,
    icon: DevicesIcon,
  },
  {
    path: '/radbot-nodes',
    Component: RadBotNodesPage,
    roles: ['MASTER_ADMIN', 'MASTER_NOC'],
    text: 'Rad Bots',
    show: true,
    icon: DevicesIcon,
  },
];
export const AppRoutes = () => {
  const role = getUserType();

  return routesList.filter((route: Route) => route.roles.includes(role));
};
